import { compile, compileG } from "./compile/emit.js";
import { vop } from "./vop.js";
const tpl = ([a, b]) => `t=${a}-${b};s+=t*t;`;
const pre = "let t,s=0;";
const $ = (dim) => distSq.add(dim, compile(dim, tpl, "a,b", void 0, "s", "", pre));
const distSq = vop();
distSq.default(compileG(tpl, "a,b", void 0, "s", pre));
const distSq2 = $(2);
const distSq3 = $(3);
const distSq4 = $(4);
export {
  distSq,
  distSq2,
  distSq3,
  distSq4
};
